import axios from 'axios';
import { url,awsUrl } from '../../axiosInstance';

export const OpenTextGet = () => {

    return axios.get(`${awsUrl}/v1/openText`, {
        headers: {
            'Authorization': `bearer ${localStorage.token}`,
        },
    })

}

export const OpenTextSet = (data) => {

    return axios.post(`${url}OpenText`,
        data, {
        headers: {
            'Authorization': `bearer ${localStorage.token}`,
            "Access-Control-Allow-Origin": "*"
        },
    })
}